/**
 * Helper styles that can be used by other components to style them like a button
 *  @example
 * const LooksLikeAButton = styled(SomeComponent)`${buttonCss}`
 */
export var buttonStyles = function buttonStyles(_ref) {
  var _ref$palette = _ref.palette,
      palette = _ref$palette === void 0 ? 'secondary' : _ref$palette,
      _ref$emphasis = _ref.emphasis,
      emphasis = _ref$emphasis === void 0 ? 'high' : _ref$emphasis,
      theme = _ref.theme;
  var text = theme.colors["".concat(palette, "Text")];
  var main = theme.colors[palette];
  var dark = theme.colors["".concat(palette, "Dark")];

  if (emphasis === 'high') {
    return "\n      color: ".concat(text, ";\n      background-color: ").concat(main, ";\n      border-color: ").concat(main, ";\n      :not([disabled]):hover {\n        background: ").concat(dark, " radial-gradient(circle, transparent 1%, ").concat(dark, " 1%) center/15000%;\n        border-color: ").concat(dark, ";\n      }\n      :not([disabled]):active {\n        background-color: ").concat(dark, ";\n        background-size: 100%;\n        transition: all 0s;\n      }\n    ");
  }

  if (emphasis === 'medium') {
    return "\n      color: ".concat(dark, ";\n      border: ").concat(theme.borders.regular, ";\n      border-color: ").concat(theme.colors.border, ";\n      background-color: transparent;\n      :not([disabled]):hover {\n        color: ").concat(dark, ";\n        border-color: ").concat(dark, ";\n        background: ").concat(theme.colors.opacityLight, " radial-gradient(circle, transparent 1%, ").concat(theme.colors.opacityLight, " 1%) center/15000%;\n      }\n      :not([disabled]):active {\n        background-color: ").concat(theme.colors.opacity, ";\n        background-size: 100%;\n        transition: all 0s;\n      }\n    ");
  }

  if (emphasis === 'low') {
    return "\n      color: ".concat(dark, ";\n      border-color: transparent;\n      background-color: transparent;\n      :not([disabled]):hover {\n        color: ").concat(main, ";\n        text-decoration: underline;\n      }\n    ");
  }

  return null;
};